import { render, staticRenderFns } from "./nav-summary.vue?vue&type=template&id=b6bf51e0"
import script from "./nav-summary.vue?vue&type=script&lang=js"
export * from "./nav-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./nav-summary.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingAnimation: require('/vercel/path0/components/ui/LoadingAnimation.vue').default,DateRange: require('/vercel/path0/components/ui/DateRange.vue').default,CustomPagination: require('/vercel/path0/components/ui/CustomPagination.vue').default})
